import { userClient, rvkadminClient } from "@/compose";

import i18n from "@/i18n";

import customerStore from "./customerStore.js";
import rhenusStore from "./rhenusStore.js";
import superUserStore from "./superUserStore.js";

import { authStore } from "@/compose";

function initial() {
  return {
    userName: null,
    contactInfo: {
      name: "Rhenus Archiv Services",
      email: "ros.servicedesk@de.rhenus.com",
      address: "Rhenus-Platz 1, 59439 Holzwickede"
    }
  };
}

export default {
  strict: process.env.NODE_ENV !== "production",
  modules: {
    customerStore,
    rhenusStore,
    superUserStore
  },
  state: initial(),
  getters: {
    userName: state => state.userName,
    contactInfo: state => state.contactInfo
  },
  mutations: {
    reset(state) {
      Object.assign(state, initial());
    },

    updateUserName(state, userName) {
      state.userName = userName;
    },
    updateContactInfo(state, info) {
      state.contactInfo = info;
    }
  },
  actions: {
    loadContactInfo(context) {
      if (authStore.hasRole("rvkCustomerUser")) {
        rvkadminClient.contactLocations().subscribe(response =>
          context.commit("updateContactInfo", {
            name: i18n.t("contact.branch", { name: response.locationName }),
            phone: response.phone,
            email: response.email,
            address: response.adress
          })
        );
      } else {
        context.commit("updateContactInfo", {
          name: "Rhenus Archiv Services – Team Digital",
          email: "support@dienstleistung.digital",
          address: "Lahnstraße 31, 12055 Berlin"
        });
      }
    }
  }
};
